import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import KeyboardArrowUpRoundedIcon from "@mui/icons-material/KeyboardArrowUpRounded";

// Floating "back to top" button for long storefront pages. Appears once the
// reader has scrolled about a screen down; route changes are handled
// separately by ScrollToTop.
const SHOW_AFTER_PX = 600;

export default function BackToTop() {
  const [visible, setVisible] = useState(false);
  // Product pages have a sticky Add to Cart bar on phones/tablets — sit above it.
  const onProductPage = useLocation().pathname.startsWith("/product/");

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > SHOW_AFTER_PX);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollUp = () => {
    const reduceMotion = window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
    window.scrollTo({ top: 0, behavior: reduceMotion ? "auto" : "smooth" });
  };

  return (
    <button
      type="button"
      onClick={scrollUp}
      aria-label="Back to top"
      title="Back to top"
      tabIndex={visible ? 0 : -1}
      className={`fixed ${onProductPage ? "bottom-24 lg:bottom-8" : "bottom-5 sm:bottom-8"} right-5 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-gradient-to-br from-[#b28585] to-[#5e3e3e] text-white shadow-lg ring-2 ring-[#F8ECD7] transition-all duration-300 hover:scale-105 hover:shadow-xl focus:outline-none focus-visible:ring-[#e0b65c] sm:right-8 ${
        visible ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-3 opacity-0"
      }`}
    >
      <KeyboardArrowUpRoundedIcon />
    </button>
  );
}
